import { ROLE_NAMES } from '@porotutu/http/vocabulary'

export {
  ACTIONS,
  type Action,
  ADMIN_OPERATORS_GRANT,
  AUDIT_KINDS,
  AUDIT_SORTABLE,
  type AuditKind,
  type AuditSort,
  assignableRolesFor,
  assignsRoles,
  EXPORT_SCOPES,
  type ExportScope,
  MANAGED_USER_LIMITS,
  MANAGED_USER_SORTABLE,
  type ManagedUserSort,
  MEMBER_OPERATORS_GRANT,
  ORGANIZATION_LIMITS,
  ORGANIZATION_SORTABLE,
  type OrganizationSort,
  PROFILE_LIMITS,
  REALMS,
  type Realm,
  ROLE_NAMES,
  type RoleName,
  raisesInto,
} from '@porotutu/http/vocabulary'

export const MANAGED_USER_ENUMS = { role: ROLE_NAMES } as const
